import { NodeType } from 'prosemirror-model';

export default function isListNode(nodeType) {
  if (nodeType instanceof NodeType) {
    return isBulletListNode(nodeType) || isOrderedListNode(nodeType);
  }
  return false;
}

function isBulletListNode(nodeType) {
  return nodeType.name === 'bulletList';
}

function isOrderedListNode(nodeType) {
  return nodeType.name === 'orderedList';
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/isListNode.js